export default {"src":"/_next/static/media/job-ready-talent.164a629e.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};